import { MenuConfig } from '@tencent/workbench';
import { MenuKey } from '../../schema/menu-schema/common';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: MenuKey.OPERATION_HOR_MENU,
    },
];
